import React, { useState, useEffect } from 'react'
import { Box, Typography, Grid, TextField, Button, Autocomplete } from '@mui/material';
import { AiOutlineLeft, AiOutlinePlusCircle } from "react-icons/ai";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import { symptoms } from './symptomList';
import useStyles from './mainStyles';
import { ROOM_DEMO, ROOM_VDPC, ROOM_URGENT_CARE } from '../../env';
import ButtonComponent from '../../components/loaderNew';
import { BiPlusCircle } from 'react-icons/bi';


const Symptoms = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(state => state.patientReducer.loading);
    const [inputFields, setInputFields] = useState([{
        MedicalConditionOther: '',
    }]);

    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const providerData = useSelector(
        state => state.patientReducer.validateUser,
    );
    const uuid = userData.user.person.uuid;
    const access_token = providerData && providerData.access_token;
    const { user } = userData && userData;
    const { person } = user && user;
    const patientDetails = useSelector(state => state.patientReducer.patientDetails);
    const { name, gender, identifier, address } = patientDetails || {};
    const docList = useSelector(
        state => state.patientReducer.docList,
    );
    const callID = useSelector(state => state.patientReducer.callID);
    const medicationStore = useSelector(
        state => state.patientReducer.medicationStore,
    );
    const allergiesStore = useSelector(
        state => state.patientReducer.allergiesStore,
    );
    const medicalConditionStore = useSelector(
        state => state.patientReducer.medicalConditionStore,
    );
    const uploadSuccess = useSelector(
        state => state.patientReducer.uploadSuccess,
    );

    const addInputMedicalConditionField = (e) => {
        e.preventDefault();
        setExtraConditions([
            ...extraConditions,
            { value: '' },
        ]);
    }
    const removeInputMedicalConditionFields = (index) => {
        let array = Object.values(extraConditions);
        array.splice(index, 1);
        setExtraConditions(array);
    }
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const [ChooseSymptoms, setChooseSymptoms] = useState([]);
    const handleSymptomsChange = (event, value) => setChooseSymptoms(value);

    const [selectedSymptoms, setSelectedSymptoms] = useState([]);
    const [expandIndex, setExpandIndex] = useState(-1);
    const [extraConditions, setExtraConditions] = useState([]);

    useEffect(() => {
        if (uploadSuccess) {
            dispatch(patientActions.uploadMedicationsSuccess(false));
            navigate('/room/preview');
        }
    }, [uploadSuccess]);


    const onSaveSconsentsSymptomsInfo = () => {
        const payload = {
            fhir_patient_id: fhir_patient_id,
            ChooseSymptoms: ChooseSymptoms ? ChooseSymptoms : null
        }
        dispatch(patientActions.addUserConsentsDetails(payload, userData.token));
    }
    const onNextSubmit = (e) => {
        e.preventDefault();
        navigate('/room/preview');
        //onSaveSconsentsSymptomsInfo();
    }
    const onSubmit = (e) => {
        e.preventDefault();
        const firstDoc = docList.length > 0 && docList[0];
        let room = ROOM_URGENT_CARE;
        if (docList.length > 0 && Object.keys(callID).length > 0) {
            // Call this once conditions are added
            let result = extraConditions.map(a => a.value);
            let syms = [...selectedSymptoms, ...result];
            const payload = {
                docId: firstDoc.id,
                groupId: firstDoc.group_id,
                symptom: syms,
                allergy: allergiesStore,
                medication: medicationStore,
                medical_condition: medicalConditionStore,
                call_id: `${callID.call_id}`,
                date_of_injury: '',
                state_of_injury: '',
                employer_name: '',
                alias: room//'vdpc',
            };
            dispatch(patientActions.storeSymptoms(syms));
            dispatch(
                patientActions.uploadMedications(
                    payload,
                    gender.toLowerCase(),
                    access_token,
                    userData && userData.user && userData.user.type_id,
                    room
                ),
            );
        }
        // navigation.navigate('eligibilityCheck');
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div style={{ padding: '10%', marginBottom: '10%' }}>
            <div style={{
                width: "100%",
                backgroundColor: "white",
                //height: "100%",
                display: "flex",
                flexDirection: "column",
            }}>
                <Typography className='topTitle' >Symptoms
            <a href="" className="backArrow" onClick={(e) => { e.preventDefault(); navigate('/room/medicalCondition') }}>
                        <AiOutlineLeft />Back</a>
                </Typography>
                <p className="Medicalconditionsinfo">
                    What symptoms is the patient calling about?
                </p>
            </div>
            <div style={{ marginTop: 20 }}>
                <Grid item >
                    {symptoms.map((item, index) => (
                        <Grid>
                            <div className="PatientMedicalInfoText">
                                <Autocomplete
                                    multiple
                                    id="tags-standard"
                                    freeSolo
                                    className="MedicalInfoSelect"
                                    onChange={(e, value, situation, option) => {
                                        if (selectedSymptoms.includes(option && option.option.title)) {
                                            let array = Object.values(selectedSymptoms);
                                            var index = array.indexOf(option && option.option.title);
                                            if (index > -1) {
                                                array.splice(index, 1);
                                            }
                                            setSelectedSymptoms(array);
                                            //setSelection(true);
                                        } else {
                                            setSelectedSymptoms([
                                                ...selectedSymptoms,
                                                option && option.option.title,
                                            ]);
                                            //setSelection(true);
                                        }
                                    }}
                                    options={item.values}
                                    getOptionLabel={(option) => option.title}
                                    // defaultValue={[symptoms[2]]}
                                    renderInput={(params) => (
                                        <TextField
                                            id={item.title}
                                            {...params}
                                            variant="filled"
                                            label={item.title}
                                        />
                                    )}
                                />
                            </div>
                        </Grid>
                    ))}
                    {/* Add Multiple Symptoms Start Here       */}
                    <div className="row">
                        <div className="col-sm-8">
                            {extraConditions ?
                                extraConditions.map((item, index) => {
                                    return (
                                        <div className="row my-3" key={index}>{(extraConditions.length >= 1) ?
                                            <TextField
                                                value={item.title}
                                                margin="normal"
                                                fullWidth
                                                variant="standard"
                                                id="medicalconditionaddmore"
                                                label="Enter Symptom"
                                                name="medicalconditionaddmore"
                                                // onChange={(e) => { console.log("e", e); }}
                                                onInput={(text) => {
                                                    //console.log("Text", text.target.value)
                                                    let array =
                                                        Object.values(extraConditions);
                                                    array[index].value = text.target.value;
                                                    setExtraConditions(array);
                                                }}
                                            />
                                            : ''}
                                            {(extraConditions.length >= 1) ?
                                                <button className="MedicalConditonRemove" onClick={(e) => { e.preventDefault(); removeInputMedicalConditionFields(index) }}>x</button>
                                                : ''
                                            }
                                        </div>)
                                }) : null
                            }
                            <div className="selectedPatientChild" onClick={addInputMedicalConditionField}>
                                <BiPlusCircle className={classes.iconchild} />
                                <span>Add Symptoms</span>
                            </div>

                        </div>
                    </div>
                    {/* Add Multiple Symptoms End Here       */}


                </Grid>

                <div className={classes.PatientNextButton}>
                    <ButtonComponent loading={loading}
                        onClick={(e) => { onSubmit(e) }} title='Next' />
                    {/* <Button
                        size="large"
                        variant="contained"
                        color='primary'
                        fullWidth
                        style={{width:'100%',padding:'3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%', marginBottom: 20, alignSelf: 'center' }}
                        disabled={loading}
                        onClick={(e) => { onSubmit(e) }}
                    >
                        Next
                    </Button> */}
                </div>
            </div>
        </div>
    )
}
export default Symptoms;
